module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_html.js
// module id = 87
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15